import { BranchSettings, BranchSettingsApi } from '../models';

export const mapBranchSettingsApiToModel = (
  apiResponse: BranchSettingsApi
): BranchSettings => {
  return {
    id: apiResponse.id,
    branchId: apiResponse.branchId,
    key: apiResponse.key,
    value: apiResponse.value,
    longValue: apiResponse.longValue,
    numberValue: apiResponse.numberValue,
    dateValue: apiResponse.dateValue,
    createdAt: apiResponse.createdAt,
    updatedAt: apiResponse.updatedAt,
  };
};
